import React from "react";

export function TeeGraphic({ color = "#FEF08A", className = "", children }) {
  return (
    <div className={`relative ${className}`}>
      <svg viewBox="0 0 300 320" className="w-full h-full drop-shadow-[4px_4px_0px_#0F172A]" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M95 20 L60 45 L20 80 L45 120 L75 105 L75 300 L225 300 L225 105 L255 120 L280 80 L240 45 L205 20 
             C205 20 190 55 150 55 C110 55 95 20 95 20 Z"
          fill={color}
          stroke="#0F172A"
          strokeWidth="5"
          strokeLinejoin="round"
        />
        <path d="M95 20 C110 45 130 52 150 52 C170 52 190 45 205 20" fill="none" stroke="#0F172A" strokeWidth="4" />
      </svg>
      {/* Chest print area — a contained, clipped region so artwork never spills onto the shirt */}
      <div
        className="absolute flex flex-col items-center justify-center text-center overflow-hidden"
        style={{ top: "26%", bottom: "18%", left: "29%", right: "29%", containerType: "inline-size" }}
      >
        {children}
      </div>
    </div>
  );
}
